module.exports = __webpack_public_path__ + "img/parrot_bg.34aa77c4.svg";